import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

/**
 * Composant d'enveloppe pour les pages qui ajoute les méta-tags appropriés
 * pour le SEO et les partages sociaux
 */
const PageWrapper = ({ children, pageType = 'default' }) => {
  // Utiliser useLocation pour obtenir le chemin actuel
  const location = useLocation();
  
  // Configurer les méta-tags en fonction du type de page
  let title = 'Conclave 2025';
  let description = 'Site web du Conclave 2025 avec annuaire des cardinaux et simulation de conclave';
  let imageUrl = '/images/conclave2025-social_image.png';
  
  // URL de base du site
  const baseUrl = 'https://conclave2025.fr';
  
  // Configurer les méta-informations selon le type de page
  switch (pageType) {
    case 'cardinaux':
      title = 'Annuaire des Cardinaux | Conclave 2025';
      description = 'Explorez les profils des cardinaux électeurs du conclave';
      imageUrl = '/images/conclave2025-cardinaux_social_image.png';
      break;
    case 'papabili':
      title = 'Papabili - Cardinaux papables | Conclave 2025';
      description = 'Découvrez quels cardinaux sont considérés comme papabili - les candidats potentiels à l\'élection papale';
      imageUrl = '/images/conclave2025-papabili_social_image.png';
      break;
    case 'conclave':
      title = 'Conclave Virtuel | Conclave 2025';
      description = 'Participez à notre simulation interactive du conclave papal et votez pour votre cardinal favori';
      imageUrl = '/images/conclave2025-conclave_social_image.png';
      break;
    case 'quiz':
      title = 'Quiz sur le Conclave | Conclave 2025';
      description = 'Testez vos connaissances sur le Collège des Cardinaux et le conclave papal';
      imageUrl = '/images/conclave2025-quiz_social_image.png';
      break;
    default:
      // Utiliser les valeurs par défaut
      break;
  }
  
  // S'assurer que l'URL de l'image est absolue
  if (imageUrl.startsWith('/')) {
    imageUrl = `${baseUrl}${imageUrl}`;
  }
  
  return (
    <>
      <Helmet>
        {/* Méta-tags de base */}
        <title>{title}</title>
        <meta name="description" content={description} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}${location.pathname}`} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl} />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={`${baseUrl}${location.pathname}`} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={imageUrl} />
      </Helmet>
      
      {children}
    </>
  );
};

export default PageWrapper;